<template>
  <div v-if="item">
    <div class="row mt-5">
      <div class="col-lg-6 px-4">
        <p class="clearfix px-2">
          <span class="float-left text-muted">{{ $t('box.object') }}</span>
          <span class="float-right">{{ objectName }}</span>
        </p>
        <p class="clearfix px-2">
          <span class="float-left text-muted">{{ $t('box.responsibleEmployee') }}</span>
          <span class="float-right">{{ employeeName }}</span>
        </p>
      </div>
      <div class="col-lg-6 px-4">
        <p class="clearfix px-2">
          <span class="float-left text-muted">{{ $t('box.startDate') }}</span>
          <span class="float-right">{{ startDate }}</span>
        </p>
        <p class="clearfix px-2">
          <span class="float-left text-muted">{{ $t('box.endDate') }}</span>
          <span class="float-right">{{ endDate }}</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <new-request-modal
          v-if="boxId"
          modal-id="new-request-modal"
          :box-id="boxId"
        ></new-request-modal>
        <div class="nav-link">
          <b-button v-b-modal="'new-request-modal'" variant="info btn-block" class="btn-icon-text">
            <i class="mdi mdi-forum"></i>
            {{ $t('button.addRequest.label') }}
          </b-button>
        </div>
      </div>
      <div class="col-lg-6">
        <router-link class="nav-link" :to="{ name: 'SettingsBox', params: { boxId: boxId } }">
          <b-button variant="warning btn-block" class="btn-icon-text">
            <i class="mdi mdi-settings"></i>
            {{ $t('button.editBox.label') }}
          </b-button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="nav-link">
          <b-button
            variant="secondary btn-block"
            class="btn-icon-text"
            @click="openEfficiencyProtocol"
          >
            <span>{{ $t('button.getEfficiencyProtocol.label') }}</span>
          </b-button>
        </div>
      </div>
      <b-modal
        id="protocol"
        v-model="protocolModal"
        title-class="centerModal"
        centered
        hide-footer
        hide-header
        size="sm"
        lazy
        footer-bg-variant="dark"
      >
        <div class="text-center">
          <div v-if="processing">
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
          </div>
          <div v-if="!processing">
            <b-button variant="primary" :href="protocolUrl" :disabled="processing">
              {{ $t('button.getEfficiencyProtocol.download') }}
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import efficiencyProtocol from '@/api/boxinfo/mutations/efficiencyProtocol.gql';

export default {
  name: 'BoxInfoFooter',
  props: {
    item: Object,
    period: Object,
    reportCode: String,
  },
  data() {
    return {
      processing: false,
      protocolUrl: '',
      protocolModal: false,
    };
  },
  computed: {
    boxId() {
      return this.item ? this.item.deviceId : '';
    },
    objectName() {
      return this.item &&
        this.item.digitalThing &&
        this.item.digitalThing.workCenter &&
        this.item.digitalThing.workCenter.itObject &&
        this.item.digitalThing.workCenter.itObject.name
        ? this.item.digitalThing.workCenter.itObject.name
        : this.$t('boxInfo.company.notDefined');
    },
    employeeName() {
      return this.item &&
        this.item.digitalThing &&
        this.item.digitalThing.workCenter &&
        this.item.digitalThing.workCenter.responsibleEmployee &&
        this.item.digitalThing.workCenter.responsibleEmployee.fullName
        ? this.item.digitalThing.workCenter.responsibleEmployee.fullName
        : this.$t('boxInfo.responsibleEmployee.notDefined');
    },
    startDate() {
      return this.toLocaleDateString(this.item.startDate);
    },
    endDate() {
      return this.item.endDate ? this.toLocaleDateString(this.item.endDate) : '-';
    },
    workCenterId() {
      return this.item && this.item.digitalThing && this.item.digitalThing.workCenter
        ? this.item.digitalThing.workCenter.id
        : null;
    },
  },
  methods: {
    toLocaleDateString(dateStr) {
      return new Date(dateStr).toLocaleDateString();
    },
    openEfficiencyProtocol() {
      this.protocolModal = true;
      this.processing = true;
      this.$apollo
        .mutate({
          mutation: efficiencyProtocol,
          variables: {
            efficiencyParams: {
              workCenterId: this.workCenterId,
              periodCode: this.reportCode,
              timeFrom: this.period.dateStart,
              timeTo: this.period && this.period.dateEnd ? this.period.dateEnd : null,
            },
          },
        })
        .then((result) => {
          this.processing = false;
          const data = result.data;
          if (data && data.koeeBoxMutation && data.koeeBoxMutation.efficiencyProtocol) {
            this.protocolUrl = data.koeeBoxMutation.efficiencyProtocol;
          } else {
            this.$bvToast.toast(this.$t('box.report.error'), {
              title: this.$t('box.report.error'),
              variant: 'danger',
              solid: true,
            });
          }
        })
        .catch((e) => {
          this.processing = false;
          console.log(e);
        });
    },
  },
};
</script>

<style></style>
